import React from 'react'
import { Alert } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { notCurrentVersionNotice } from './operationVersionNoticeRule'

/**
 * OperationVersionNotice — story 184 (CU4 · CA7, CA8). The warning the OPERATIONS view shows right above General
 * Properties when the version loaded into the accordions is not the current one of its code (RN-05.2). It is a
 * help, not a gate: nothing is blocked, with or without `OPERATION_LIBRARY_EDIT` (RN-05.7). Renders nothing when
 * `notCurrentVersionNotice` says so (current version, new operation, unknown current — D2).
 *
 * Props: the loaded version (`nodeId`, `versionNumber`, `isNew`) and `currentVersionNumber` as read from N2 at
 * load time (RN-05.4, RN-05.10).
 */
const OperationVersionNotice = ({ nodeId = '', versionNumber = 0, isNew = false, currentVersionNumber = null }) => {
  const { t_ } = useSmartTranslation()
  const notice = notCurrentVersionNotice({ nodeId, versionNumber, isNew }, currentVersionNumber)
  if (notice === null) return null
  return (
    <Alert severity='warning' data-testid='operation-not-current-notice' sx={{ mb: 1 }}>
      {t_('Version {{version}} is not the current one: the current version is {{current}}', notice)}
    </Alert>
  )
}

export default OperationVersionNotice
